module.exports = __webpack_public_path__ + "static/media/ic_password_regular.30ea7f30.svg";